<template>
  <div class="discount-management">
    <!-- 搜尋與功能區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input type="text" placeholder="搜尋優惠" v-model="searchQuery" />
      </div>
    </div>
    <button class="action-button primary" @click="openNewModal">新增方案</button>
    <!-- 表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <th>優惠方案編號</th>
          <th>方案名稱</th>
          <th>方案價格</th>          
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pkg in paginatedPackages" :key="pkg.id">
          <td>{{ pkg.id }}</td>
          <td>{{ pkg.name }}</td>
          <td>NT$ {{ pkg.basePrice }}</td>
          <td>
            <button @click="editPackage(pkg)" class="btn btn-edit">
              編輯
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 新增方案彈窗 -->
    <div v-if="showNewModal" class="new-modal">
      <div class="modal-content">
        <h2>新增優惠方案</h2>
        <div class="form-group">
          <label>方案名稱</label>
          <input v-model="newPackageData.name" placeholder="請輸入方案名稱" />
        </div>
        <div class="form-group">
          <label>方案價格</label>
          <input
            type="number"
            v-model.number="newPackageData.basePrice"
            placeholder="請輸入方案價格"
          />
        </div>
        <div class="modal-actions">
          <button class="update-button" @click="addPackage">新增</button>
          <button class="cancel-button" @click="closeNewModal">取消</button>
        </div>
      </div>
    </div>
    <!-- 編輯彈窗 -->
    <div v-if="showEditModal" class="edit-modal">
      <div class="modal-content">
        <h2>編輯優惠方案</h2>
        <div class="form-group">
          <label>方案編號</label>
          <input v-model="editPackageData.id" disabled />
        </div>
        <div class="form-group">
          <label>方案名稱</label>
          <input v-model="editPackageData.name" />
        </div>
        <div class="form-group">
          <label>方案價格</label>
          <input type="number" v-model.number="editPackageData.basePrice" />
        </div>
        <div class="modal-actions">
          <button class="update-button" @click="saveEdit">保存</button>
          <button class="delete-button" @click="confirmDelete">刪除</button>
          <button class="cancel-button" @click="closeEditModal">取消</button>
        </div>
      </div>
    </div>

    <!-- 分頁按鈕 -->
    <div class="pagination">
      <button class="page-btn" :disabled="!hasPreviousPage" @click="prevPage">
        « Previous
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        :class="['page-number', { active: page === currentPage }]"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-btn" :disabled="!hasNextPage" @click="nextPage">
        Next »
      </button>
    </div>
  </div>
</template>

<script>
import ddbLogic from "@/assets/js/background/ddb.js";

export default {
  name: "DiscountManagement",
  mixins: [ddbLogic],
};
</script>

<style src="@/assets/css/background/ddb.css" scoped></style>